/* eslint-disable react/prop-types */
import clsx from 'clsx'
import type { BooleanCell } from '../types'
import { createRenderer } from './renderer'
import { ComboCell } from './enum'
import { NOL } from './null'

export const Booleans = createRenderer<BooleanCell>({
  View: ({ className, cell }) => {
    if (cell.value === null) {
      return <NOL />
    }
    return (
      <div className={clsx(className, 'text-xs', { 'computed-cell': cell.computed })}>
        {cell.value === true ? 'TRUE' : 'FALSE'}
      </div>
    )
  },
  Editor: ({ className, cell, row, onCellChange }) => {
    const comboboxOptions = [
      { value: 'true', label: 'TRUE' },
      { value: 'false', label: 'FALSE' },
      { value: 'null', label: 'NULL' },
    ]

    const handleValueChange = (value: string) => {
      const booleanValue = value === 'true' ? true : value === 'false' ? false : null

      onCellChange?.(
        row,
        {
          type: 'boolean',
          value: booleanValue,
        },
        true
      )
    }

    const currentValue = cell.value === true ? 'true' : cell.value === false ? 'false' : 'null'

    return (
      <ComboCell
        options={comboboxOptions}
        value={currentValue}
        open={true}
        onValueChange={handleValueChange}
        placeholder="Select value..."
        emptyText="No values found."
        className={clsx(className, { 'computed-cell': cell.computed })}
      >
        <div className="pl-2">{cell.value === true ? 'TRUE' : cell.value === false ? 'FALSE' : 'NULL'}</div>
      </ComboCell>
    )
  },
})
